import { render, staticRenderFns } from "./DialogSuccessIcon.vue?vue&type=template&id=63cd1a46"
import script from "./DialogSuccessIcon.vue?vue&type=script&lang=ts"
export * from "./DialogSuccessIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports